module.exports = __webpack_public_path__ + "img/dodger-stadium_field-access.a55d2cff.jpg";